import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const PrivacyPolicy = () => {
     
  return (
    <div>
      <Navbar />
      <div style={{ padding: '2rem', maxWidth: '800px', margin: '0 auto', fontFamily: 'Arial, sans-serif' }}>
      <h1>Privacy Policy</h1>
      <p><strong>Effective Date:</strong> July 9, 2025</p>

      <p>
        QMX Technology ("we", "our", or "us") is committed to protecting your privacy.
        This Privacy Policy explains how we collect, use, and safeguard your information
        when you interact with our services.
      </p>

      <h2>1. Information We Collect</h2>
      <p>We only collect the following personal information:</p>
      <ul>
        <li><strong>Phone Number</strong></li>
      </ul>
      <p>This information may be collected when you:</p>
      <ul>
        <li>Fill out a contact form</li>
        <li>Sign up for our services</li>
        <li>Communicate with us via messaging platforms or other channels</li>
      </ul>

      <h2>2. How We Use Your Information</h2>
      <p>We use your phone number solely for the following purposes:</p>
      <ul>
        {/* <li>To respond to inquiries or customer support requests</li> */}
        <li>To send important service-related notifications</li>
        {/* <li>To communicate with you about updates, offers, or relevant information (only if you’ve opted in)</li> */}
      </ul>

      <h2>3. How We Share Your Information</h2>
      <p>
        We do <strong>not</strong> sell, trade, or rent your phone number to any third parties.
        We may share your information only when:
      </p>
      <ul>
        <li>Required by law or government request</li>
        <li>Necessary to protect our rights or enforce our terms</li>
        <li>
          Working with trusted service providers who help us operate our business
          (under strict confidentiality)
        </li>
      </ul>

      <h2>4. Data Security</h2>
      <p>
        We take reasonable steps to protect your phone number from unauthorized access,
        loss, or misuse. However, no method of transmission over the internet or storage
        is 100% secure.
      </p>

      <h2>5. Your Rights</h2>
      <p>You have the right to:</p>
      <ul>
        <li>Request access to the information we hold about you</li>
        <li>Request correction or deletion of your phone number</li>
        <li>Withdraw consent for communication at any time</li>
      </ul>
      <p>To exercise these rights, please contact us at <strong>info@qmxtech.co.za</strong>.</p>

      <h2>6. Contact Information</h2>
      <p>
        If you have any questions about this Privacy Policy or your personal information,
        please contact us:
      </p>
      <address>
        <strong>QMX Technology</strong><br />
        Johannesburg, South Africa<br />
        📧 Email: <a href="mailto:admin@qmxtechnology.co.za">admin@qmxtechnology.co.za</a>
      </address>

      <h2>7. Changes to This Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. Any changes will be posted
        on this page with an updated effective date.
      </p>
        <Footer />
    </div>
    </div>
  );
  
};

export default PrivacyPolicy;
